import { ButtonLink } from '../Button'
import '../StatusScreen/StatusScreen.css'

/** Shown in place of a feature this build hides (see lib/alpha.ts), so a stray link lands somewhere calm, not a 404. */
export function ComingSoonPage() {
  return (
    <section className="status-screen">
      <h1 className="status-screen__title">Coming soon</h1>
      <p className="status-screen__detail">This part of MentorFox isn't open yet.</p>
      <ButtonLink to="/">Back to home</ButtonLink>
    </section>
  )
}
